import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setPageTemplate: YJSChangeHandler<DatabaseChangeType.SET_PAGE_TEMPLATE> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.pageTemplateId = change.newPageTemplate.templateId;
  });
};
